import type { ReactNode } from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';

/** Prev / center-label / next header for the calendar views (appointment week,
 *  call day agenda, specialist week). The center content is a slot so each
 *  caller controls its own label markup. */
export function CalendarNav({
  onPrev,
  onNext,
  prevLabel,
  nextLabel,
  children,
}: {
  onPrev: () => void;
  onNext: () => void;
  prevLabel: string;
  nextLabel: string;
  children: ReactNode;
}) {
  return (
    <header className="flex items-center justify-between gap-2 border-b border-border px-4 py-3">
      <button
        type="button"
        onClick={onPrev}
        aria-label={prevLabel}
        className="inline-flex items-center justify-center rounded p-1 text-muted-foreground hover:bg-muted hover:text-foreground"
      >
        <ChevronLeft className="h-4 w-4" />
      </button>
      {children}
      <button
        type="button"
        onClick={onNext}
        aria-label={nextLabel}
        className="inline-flex items-center justify-center rounded p-1 text-muted-foreground hover:bg-muted hover:text-foreground"
      >
        <ChevronRight className="h-4 w-4" />
      </button>
    </header>
  );
}
